//src/components/OrdersPage/ProductOrderPage/ProductOrderPage.jsx

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { authFetch } from "../../api/api";
import Card from "../../UI/Card";
import Button from "../../UI/Button";
import AddProductModal from "./AddProductModal";
import ConfirmModal from "../../UI/ConfirmModal";
import { useTranslation } from "react-i18next";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const API_URL = `${BASE_URL}/api/orders/`;
const ORDER_ITEMS_API = `${BASE_URL}/api/order-items/`;

export default function ProductOrderPage() {
  const { id } = useParams(); // order id

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [editingItem, setEditingItem] = useState(null);

  const { t } = useTranslation("OrdersPage");

  useEffect(() => {
    const loadOrder = async () => {
      try {
        const res = await authFetch(`${API_URL}${id}/`);
        const data = await res.json();
        setOrder(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    loadOrder();
  }, [id]);

  if (loading) return <p>{t("loading")}</p>;
  if (!order) return <p>{t("not_found")}</p>;

  const items = order.items || [];

  const handleDelete = async () => {
    if (!itemToDelete) return;

    try {
      const res = await authFetch(`${ORDER_ITEMS_API}${itemToDelete.id}/`, {
        method: "DELETE",
      });

      if (!res.ok) throw new Error(t("delete_error"));

      setOrder((prev) => ({
        ...prev,
        items: prev.items.filter((i) => i.id !== itemToDelete.id),
      }));

      setShowDeleteConfirm(false);
      setItemToDelete(null);
    } catch (e) {
      console.error(e);
      alert(t("delete_error"));
    }
  };

  return (
    <div className="w-full max-w-5xl mx-auto mt-10 space-y-6">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">
          {t("order_products")} #{order.order_code}
        </h1>

        <Button onClick={() => setShowModal(true)}>
          {t("add_product")}
        </Button>
      </div>

      {/* ITEMS */}
      <div className="space-y-3">
        {items.length === 0 ? (
          <p className="text-gray-500">{t("no_products")}</p>
        ) : (
          items.map((item) => {
            const p = item.product_data || {};

            return (
            <Card key={item.id} className="p-4">
                <p className="font-semibold">
                {p.name_en} / {p.name_cn}
                </p>
                <div className = "flex justify-end gap-2">
                  <Button
                    variant="edit"
                    onClick={() => {
                        setEditingItem(item);
                        setShowModal(true);
                      }}
                  >
                    {t("edit")}
                  </Button>

                  <Button
                    variant="danger"
                    onClick={() => {
                      setItemToDelete(item);
                      setShowDeleteConfirm(true);
                    }}
                  >
                    {t("delete")}
                  </Button>
                </div>

              <p>{t("quantity")}: {item.quantity}</p>
              <p>{t("client")}: ¥{item.client_price}</p>
              <p>{t("purchase_price")}: ¥{item.purchase_price}</p>

              <p className="text-green-600 font-medium">
                {t("profit")}: ¥{item.profit}
              </p>

              {/* комментарий */}
              {item.comment && (
              <div className="text-sm text-gray-600 mt-2">
                <b>Комментарий:</b>{" "}
                {item.comment?.trim() ? item.comment : "— нет комментария —"}
              </div>
              )}
            </Card>
            );
          })
        )}
      </div>
      {showModal && (
    <AddProductModal
      orderId={id}
      clientId={order.client}
      editItem={editingItem}   // 👈 ВОТ ЭТО ДОБАВЬ
      onClose={() => {
        setShowModal(false);
        setEditingItem(null);
      }}
      onSuccess={() => {
        setShowModal(false);
        setEditingItem(null);
        window.location.reload();
      }}
    />
)}

{showDeleteConfirm && (
  <ConfirmModal
    isOpen={showDeleteConfirm}
    onClose={() => {
      setShowDeleteConfirm(false);
      setItemToDelete(null);
    }}
    onConfirm={handleDelete}
    title={t("confirm_delete_title")}
    description={
      <>
        {t("confirm_delete_product")}{" "}
        <span className="font-semibold">
          {itemToDelete?.product_data?.name_en}
        </span>
        ?
      </>
    }
    confirmText={t("delete")}
  />
)}

    </div>
  );
}